/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ locale: NonNullable<unknown> }} Blog_Ai_Polish_HintInputs */

const cs_blog_ai_polish_hint = /** @type {(inputs: Blog_Ai_Polish_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Upraví titulek, perex a tělo článku pouze v jazyce ${i?.locale}.`)
};

const en_blog_ai_polish_hint = /** @type {(inputs: Blog_Ai_Polish_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Improves title, excerpt, and body in ${i?.locale} only.`)
};

/**
* | output |
* | --- |
* | "Improves title, excerpt, and body in {locale} only." |
*
* @param {Blog_Ai_Polish_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_polish_hint = /** @type {((inputs: Blog_Ai_Polish_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_Polish_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_polish_hint(inputs)
	return cs_blog_ai_polish_hint(inputs)
});